import React from "react";
import clsx from "clsx";

import "./index.scss";

import PcInputTitle from "components/molecules/PcInputTitle";

const PcAccordionInput = ({
  title,
  label,
  list,
  type,
  visible,
}) => {
  return (
    <div className="PcAccordionInput">
      <div className="pc-accordion-radio-area-wrapper">
        <div className={clsx('pc-cmnt-area', { visible })}>
          <div className="arrowArea"></div>
          <div className="pcCollpseAreaBackground">
            <PcInputTitle
              title={title}
              label={label}
              list={list}
              type={type}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PcAccordionInput;
